export default {
  fields: {
    online_shop_domain: 'Własna domena sklepu internetowego',
    online_shop_domain_hint:
      'Domena restauracji, np. order.pizzeria-mario.com — tylko do zamówień; strona internetowa potrzebuje innej. Po zapisaniu pojawią się tu rekordy do dodania.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
